export default "__VITE_ASSET__579bcd7e__"